

const TrustSection = () => {
  const features = [
    {
      icon: 'ri-database-2-line',
      title: 'Kapsamlı Veri Analizi',
      description: 'Milyonlarca veri noktası gerçek zamanlı işlenir',
    },
    {
      icon: 'ri-cpu-line',
      title: 'Algoritmik Değerlendirme',
      description: 'Gelişmiş AI modelleri ile akıllı karar üretimi',
    },
    {
      icon: 'ri-layout-grid-line',
      title: 'Sade Sunum',
      description: 'Karmaşık verileri anlaşılır formatta sunuyoruz',
    },
  ];

  return (
    <section className="py-16 sm:py-24 lg:py-32 bg-dark relative overflow-hidden">
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0icmdiYSgxNiwgMTg1LCAxMjksIDAuMSkiIHN0cm9rZS13aWR0aD0iMSIvPjwvcGF0dGVybj48L2RlZnM+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNncmlkKSIvPjwvc3ZnPg==')] opacity-20"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="text-center lg:text-left order-2 lg:order-1">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-beige-light mb-4 sm:mb-6 leading-tight">
              Finansal Veriyi Anlamlı Karara Dönüştürüyoruz
            </h2>
            <p className="text-base sm:text-lg text-beige/70 leading-relaxed mb-6 sm:mb-8">
              BAGA, piyasa verilerini toplamakla kalmaz, aynı zamanda bu verileri anlamlı içgörülere dönüştürür. Gelişmiş algoritmalarımız, karmaşık finansal verileri sade ve eyleme geçirilebilir kararlara çevirir.
            </p>
            <p className="text-base sm:text-lg text-beige/70 leading-relaxed mb-8 sm:mb-10">
              Amacımız, yatırımcıların piyasayı daha iyi anlamalarını ve daha bilinçli kararlar almalarını sağlamaktır. Teknolojimiz, sürekli öğrenen ve gelişen bir yapıya sahiptir.
            </p>

            <div className="space-y-4 sm:space-y-6">
              {features.map((feature, index) => (
                <div key={index} className="flex items-start gap-3 sm:gap-4 text-left">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-emerald/10 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className={`${feature.icon} text-emerald text-lg sm:text-xl`}></i>
                  </div>
                  <div>
                    <h4 className="text-beige-light font-semibold text-base sm:text-lg mb-1">{feature.title}</h4>
                    <p className="text-beige/70 text-sm">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="relative order-1 lg:order-2">
            <div className="relative">
              <img 
                src="https://public.readdy.ai/ai/img_res/9ef9d459890585a88800d2ca7da85e72.jpg"
                alt="BAGA Teknoloji"
                className="w-full h-auto rounded-2xl shadow-2xl"
              />
              
              <div className="absolute -bottom-4 -right-4 sm:-bottom-6 sm:-right-6 bg-dark-card border border-emerald/30 rounded-xl p-4 sm:p-6 shadow-xl">
                <div className="flex items-center gap-2 sm:gap-3 mb-1 sm:mb-2">
                  <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 bg-emerald rounded-full animate-pulse"></div>
                  <span className="text-beige-light font-semibold text-xs sm:text-sm">Canlı Sistem</span>
                </div>
                <div className="text-beige/70 text-xs">7/24 Aktif Tarama</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustSection;
